module.exports = __webpack_public_path__ + "img/appreciateRegister.96b4ebbd.png";